import { FunctionComponent, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { LoadingSpinner, PageContainer, PageTitle } from "src/components/generic";
import SquareTile from "src/components/generic/tiles/SquareTile";
import { ToastStatus, useToast } from "src/context/ToastContext";
import { dynamo } from "src/utils";
import { Client } from "src/utils/types/UserTypes";


const CreditPullApplication: FunctionComponent = () => {
    const { id, appId } = useParams();
    const { setToast } = useToast();
    const [client, setClient] = useState<Client | null>(null);
    const [application, setApplication] = useState<Record<any, any> | null>(null);

    const fetchClient = async () => {
        if (!id) return;

        try {
            const result = await dynamo.fetch.userById(id);
 
            setClient(result.user);
        } catch (error: any) {
            setToast({
                message: error?.message || "Failed to Fetch Client",
                status: ToastStatus.FAIL
            });
        }
    };

    const fetchCreditApplication = async () => {
        if (!appId) return;

        try {
            const result = await dynamo.fetch.creditApplicationById(appId);

            setApplication(result);
        } catch (error: any) {
            setToast({
                message: error?.message || "Failed to Fetch Application",
                status: ToastStatus.FAIL
            });
        }
    }

    useEffect(() => {
        fetchClient();
    }, [id]);

    useEffect(() => {
        fetchCreditApplication();
    }, [appId]);
    

    if(!client || !application) return <LoadingSpinner />
    return (
        <PageContainer>
            <PageTitle title={`Soft Credit Pull Application - ${application.metadata.applicationSubmit}`} />

            <SquareTile title="Application Info">
                <p><span className="font-semibold">Name:</span> {application.applicationFormData.name}</p>
                <p><span className="font-semibold">Email:</span> {application.applicationFormData.email}</p>
                <p><span className="font-semibold">Phone:</span> {application.applicationFormData.phone}</p>
                <p><span className="font-semibold">Date of Birth:</span> {application.applicationFormData.dob}</p>
                <p><span className="font-semibold">Address:</span> {application.applicationFormData.address}</p>
                <p><span className="font-semibold">City:</span> {application.applicationFormData.city}</p>
                <p><span className="font-semibold">State:</span> {application.applicationFormData.state}</p>
                <p><span className="font-semibold">Zip:</span> {application.applicationFormData.zip}</p>
                <p><span className="font-semibold">State:</span> {application.applicationFormData.state}</p>
                <p className="text-success"><span className="font-semibold">Consent Given:</span> {application.applicationFormData.consent}</p>
            </SquareTile>
        </PageContainer>
    )
}

export default CreditPullApplication;